$(function () {
	var www = $(window).width();
	var hhh = $(window).height();
	var preTop;

	const legArr = ["STEEL PIPE LEG", "L LEG", "SQUARE LEG", "FOLDING LOW LEG", "FOLDING LEG", "COMPASS WOOD LEG", "POLE LEG-S", "POLE LEG-C", "TOP CIRCLE", "TOP SQUARE"];
	const legArr2 = ["DESK & TABLE WOOD / ", "DESK & TABLE LINOLEUM / ", "DESK WOOD / ", "DESK LINOLEUM / ", "TABLE WOOD / ", "TABLE LINOLEUM / ", "aaaaa", "aaaaa", "aaaaa"];

	/*-------------------------------------
URL
-------------------------------------*/

	// URLのアンカー（#以降の部分）を取得
	var urlHash = location.hash;

	// URLにアンカーが存在する場合
	if (urlHash) {
		// アンカーが#osakaかどうかを判断する
		if (urlHash.indexOf("sec") != -1) {
			setTimeout(function () {
				var target = $(urlHash);
				var sa = 0;

				if (www > 980) {
					sa = 160;
				} else {
					sa = 0;
				}

				var position = target.offset().top - sa;
				//console.log(position);
				$("html, body").stop().animate({ scrollTop: position }, 500, "swing");
			}, 10);
		} else {
			//
		}
	}

	/*-------------------------------------
SORT
-------------------------------------*/

	// /collections/all?filter.v.price.gte=&filter.v.price.lte=&filter.p.tag=HOOK&sort_by=manual
	var url = new URL(location);
	//console.log(url);
	var nowURL = url.origin + url.pathname;
	//nowURL = url.origin + '/collections/all';
	var params = new URLSearchParams(window.location.search);
	//console.log(params);

	var tmpGte = params.get("filter.v.price.gte");
	var tmpLte = params.get("filter.v.price.lte");
	var tmpSort = params.get("sort_by");
	var tmpTags = params.getAll("filter.p.tag");

	//console.log(tmpGte);
	//console.log(tmpLte);
	//console.log(tmpSort);
	//console.log(tmpTags);

	if (tmpGte != "") {
		$('[data-value="' + tmpGte + '"]').addClass("active");
	}
	if (tmpLte != "") {
		$('[data-value="' + tmpLte + '"]').addClass("active");
	}
	if (tmpSort != "") {
		$('[data-value="' + tmpSort + '"]').addClass("active");
	}
/*
	if (tmpTag != "") {
		$('[data-value="' + tmpTag + '"]').addClass("active");
	}
*/
	tmpTags.forEach(function (tmpTag) {
		$('[data-filter="tag"][data-value="' + tmpTag + '"]').addClass("active");
	});


	$(".select_category__current").each(function (index) {
		var tmpCurrent = $(this).find(".current");
		var tmpValue = $(this).find("a.active").html();
		tmpCurrent.html(tmpValue);
	});

	function checkFilterTtl() {
		if (www < 719) {
			$(".eachFilter").each(function (index) {
				var tmpFilterTtl = $(this).find(".ttl");
				var tmpValue = $(this).find("a.active").html();

				//console.log(tmpFilterTtl);
				//console.log(tmpValue);

				if (tmpValue == undefined) {
					tmpFilterTtl.show();
				} else {
					tmpFilterTtl.hide();
				}
			});
		}
	}
	checkFilterTtl();

	if (www < 719) {
		$(".filterBox").hide();
	}
	$(".filterTtl").click(function () {
		$(this).toggleClass("active");

		$(".filterBox").slideToggle(300);

		// if ($(this).hasClass("active")) {
		// 	$(".filterBox").css("display", "flex");
		// } else {
		// 	$(".filterBox").css("display", "none");
		// }
	});

	$(".select_category__pulldown_item a").click(function () {
		var tmpLink = $(this);
		var tmpBox = $(this).closest(".select_category__current");
		var tmpTtl = $(this).html();

		tmpBox.find(".current").html(tmpTtl);
		tmpBox.find("a").not(tmpLink).removeClass("active");
		tmpLink.addClass("active");

		var newURL = "?";

		$(".select_category__pulldown_item a.active").each(function (index) {
			var tmpFilter = $(this).data("filter");
			var tmpValue = $(this).data("value");
			tmpValue = encodeURIComponent(tmpValue);

			/*
			if(tmpFilter==undefined){
				return false;
			}
*/

			//console.log(tmpFilter);
			//console.log(tmpValue);

			if (tmpFilter == "gte") {
				newURL = newURL + "filter.v.price.gte=" + tmpValue + "&";
			}
			if (tmpFilter == "lte") {
				newURL = newURL + "filter.v.price.lte=" + tmpValue + "&";
			}
			if (tmpFilter == "sort_by") {
				newURL = newURL + "sort_by=" + tmpValue + "&";
			}
			if (tmpFilter == "tag" && tmpValue !== "") {
				newURL = newURL + "filter.p.tag=" + tmpValue + "&";
			}
		});

		if (url.pathname.indexOf("furniture") !== -1 && url.pathname.indexOf("hardware-furniture") < 0) {
			newURL = url.origin + "/collections/furniture" + newURL;
		} else if (url.pathname.indexOf("hardware") !== -1) {
			newURL = url.origin + "/collections/hardware" + newURL;
		} else if (url.pathname.indexOf("accessory") !== -1) {
			newURL = url.origin + "/collections/accessory" + newURL;
		} else if (url.pathname.indexOf("lighting-electricity") !== -1) {
			newURL = url.origin + "/collections/lighting-electricity" + newURL;
		} else if (url.pathname.indexOf("vintage") !== -1) {
			newURL = url.origin + "/collections/vintage" + newURL;
		} else {
		}

		//console.log(url.origin);
		//console.log(url.pathname);

		//newURL = nowURL + newURL;
		//console.log(newURL);
		//console.log(url.pathname.indexOf('hardware-furniture'));

		window.location.href = newURL;

		//checkFilterTtl();

		return false;
	});

	$(".select_category__pulldown_project li a").click(function () {
		var tmpLink = $(this);
		var tmpBox = $(this).closest(".select_category__current");
		var tmpTtl = $(this).html();

		tmpBox.find(".current").html(tmpTtl);
		tmpBox.find("li a").not(tmpLink).removeClass("active");
		tmpLink.addClass("active");

		$(".projectsList li").fadeIn(300);
		//$(".projectsList li").removeClass("active");

		var filterCategory = $(".select_category__pulldown_project ul.filterCategory a.active").text();
		if (filterCategory == "VIEW ALL") {
			filterCategory = "";
		}

		var filterYear = $(".select_category__pulldown_project ul.filterYear a.active").text();
		if (filterYear == "VIEW ALL") {
			filterYear = "";
		}

		var filterSort = $(".select_category__pulldown_project ul.filterSort a.active").text();
		if (filterSort == "VIEW ALL") {
			filterSort = "";
		}

		//console.log(filterCategory);
		//console.log(filterYear);
		//console.log(filterSort);

		$(".projectsList li").each(function (index) {
			var tmpCategory = $(this).data("kind");
			var tmpYear = $(this).data("year");

			if (filterCategory != "" && filterYear != "") {
				if (tmpCategory == filterCategory && tmpYear.indexOf(filterYear) !== -1) {
					$(this).fadeIn(300);
				} else {
					$(this).hide();
				}
			} else if (filterCategory != "") {
				if (tmpCategory == filterCategory) {
					$(this).fadeIn(300);
				} else {
					$(this).hide();
				}
			} else if (filterYear != "") {
				if (tmpYear.indexOf(filterYear) !== -1) {
					$(this).fadeIn(300);
				} else {
					$(this).hide();
				}
			}

			if (filterSort == "NEWEST") {
				var $elements = $(".projectsList li").sort(function (a, b) {
					var aa = $(a).data("year");
					var bb = $(b).data("year");

					if (aa > bb) {
						return -1;
					} else if (aa < bb) {
						return 1;
					}
					return 0;
				});
				$(".projectsList").empty();
				$elements.each(function () {
					$(".projectsList").append($(this));
				});
			}

			if (filterSort == "OLDEST") {
				var $elements = $(".projectsList li").sort(function (a, b) {
					var aa = $(a).data("year");
					var bb = $(b).data("year");

					if (aa > bb) {
						return 1;
					} else if (aa < bb) {
						return -1;
					}
					return 0;
				});
				$(".projectsList").empty();
				$elements.each(function () {
					$(".projectsList").append($(this));
				});
			}
		});

		return false;
	});

	/*-------------------------------------
SCROLL
-------------------------------------*/

	$(window).on("resize", adjustScroll);

	//scroll
	var scrollTimer;
	$(window).bind("scroll touchmove", function () {
		clearInterval(scrollTimer);
		scrollTimer = setInterval(function () {
			adjustScroll();
			clearInterval(scrollTimer);
		}, 10);
	});
	//adjustScroll();

	var preDocViewTop = 0;
	var docViewTop = 0;
	var hideFlg = true;

	function adjustScroll() {
		docViewTop = $(window).scrollTop();
		hhh = $(window).height();
		www = $(window).width();

		if (hideFlg) {
			if (docViewTop > preDocViewTop && docViewTop > 60) {
				$("header").addClass("hide");
				//$("#button_container").addClass("hide");
			} else {
				$("header").removeClass("hide");
				//$("#button_container").removeClass("hide");
			}
		}

		preDocViewTop = docViewTop;
	}

	/*-------------------------------------
MENU
-------------------------------------*/

	$("#button_container").click(function () {
		$("html,body").toggleClass("hiddenBox");
		$("#toggle").toggleClass("active");
		$("#overlay").toggleClass("open");

		if ($("html,body").hasClass("hiddenBox")) {
			preTop = $(window).scrollTop();

			setTimeout(function () {
				$("html, body").animate({ scrollTop: 0 }, 0, "swing");
			}, 1);
		} else {
			setTimeout(function () {
				$("html, body").animate({ scrollTop: preTop }, 0, "swing");
			}, 1);
		}
	});

	$("#overlay ul li a").click(function () {
		//$("#toggle").removeClass("active");
		//$("#overlay").removeClass("open");
	});

	$(".navSpListMany > li > a").click(function () {
		var tmp = $(this);
		var target = tmp.next("ul");

		$(".navSpListMany > li > ul").not(target).slideUp(300);
		target.slideToggle(300);

		$(".navSpListMany > li > a").not(tmp).removeClass("open");
		tmp.toggleClass("open");

		return false;
	});

	$(".navSpListMany > li > .subList > li > a").click(function () {
		var tmp = $(this);
		var target = tmp.next("ul");

		$(".navSpListMany > li > .subList > li > ul").not(target).slideUp(300);

		target.slideToggle(300);

		$(".navSpListMany > li > .subList > li > a").not(tmp).removeClass("open");
		tmp.toggleClass("open");

		return false;
	});

	$(".detailInfoList > li > .ttl").click(function () {
		var tmp = $(this);
		var target = tmp.next(".desp");

		$(".detailInfoList > li > .desp").not(target).slideUp(300);
		target.slideToggle(300);

		$(".detailInfoList > li > .ttl").not(tmp).removeClass("open");
		tmp.toggleClass("open");

		if (www > 980) {
			var sa = 160;
		} else {
			var sa = 80;
		}

		var position = $(".detailInfoList").offset().top - sa;
		$("html, body").animate({ scrollTop: position }, 300, "swing");

		return false;
	});

	/*-------------------------------------
FOOTER
-------------------------------------*/

	if (www > 719) {
	} else {
		$(".ftNavEach .ttl").click(function () {
			var tmp = $(this);
			var target = tmp.next(".ftNavList");

			$(".ftNavEach .ftNavList").not(target).slideUp(300);
			target.slideToggle(300);

			return false;
		});
	}

	/*-------------------------------------
HEADER
-------------------------------------*/

	$(".tabBtnClick").click(function () {
		$("#searchArea").fadeToggle(300);

		return false;
	});
	$("#searchArea").click(function () {
		$("#searchArea").fadeOut(100);

		return false;
	});
	$(".searchBox").click(function () {
		return false;
	});

	$(".searchBtn").click(function () {
		$(this).closest(".searchBox").submit();

		return false;
	});

	var tabTimer;

	$(".tabBtnHover").hover(
		function () {
			clearInterval(tabTimer);

			// if (www < 719) {
			// 	preTop = $(window).scrollTop();
			// 	//console.log(preTop);
			// 	setTimeout(function () {
			// 		$("html,body").addClass("hiddenBox");
			// 	}, 100);
			// }

			var linkBtn = $(this);
			$(".tabBtnHover").not(linkBtn).removeClass("activeTab");
			linkBtn.addClass("activeTab");

			var target = linkBtn.data("tab");
			target = "#" + target;
			target = $(target);

			//open
			$(".tabBox").not(target).removeClass("active");

			target.addClass("active");
			$("#bgBlack").stop().fadeIn(300);
			//$("header").addClass("whiteBgTab");

			return false;
		},
		function () {
			//
		},
	);

	$("#bgBlack,.tabFade").hover(
		function () {
			fadeOutTab();
		},
		function () {
			//
		},
	);
	$(".tabAllBoxFade").hover(
		function () {
			clearInterval(tabTimer);
		},
		function () {
			fadeOutTab();
		},
	);

	function fadeOutTab() {
		tabTimer = setTimeout(function () {
			// if (www < 719) {
			// 	console.log(preTop);
			// 	$("html,body").removeClass("hiddenBox");

			// 	setTimeout(function () {
			// 		$("html, body").animate({ scrollTop: preTop }, 0, "swing");
			// 	}, 100);
			// }

			$(".tabBox").removeClass("active");
			$("#bgBlack").stop().fadeOut(300);
			$(".tabBtnHover").removeClass("activeTab");
		}, 100);
	}

	$(".pageList li a").click(function () {
		var pageBtn = $(this);
		var box = $(this).closest(".container");

		box.find(".pageList li a").not(pageBtn).removeClass("activePage");
		pageBtn.addClass("activePage");

		var index = box.find(".pageList li a").index(pageBtn);
		console.log(index);

		var target = box.find(".pageEach").eq(index);
		console.log(target);

		if (pageBtn.hasClass("activePage")) {
			box.find(".pageEach").not(target).hide();
			target.stop().fadeIn(600);
		} else {
		}

		return false;
	});

	$("#bgBlack").click(function () {
		//fadeOutだとdisplay:noneが残り、以降メニューが開かなくなるためclassで閉じる
		$(".tabBtnHover").removeClass("activeTab");

		$(".tabBox").removeClass("active");
		$("#bgBlack").stop().fadeOut(300);

		return false;
	});

	$(".headNews .close").click(function () {
		$(".headNews").slideUp(300);

		$("main").addClass("mini");
		$("#button_container").addClass("mini");
	});

	/*-------------------------------------
TOP
-------------------------------------*/

	var topSwiper = new Swiper(".topSwiper", {
		// Optional parameters
		loop: true,
		effect: "slide",
		autoplay: {
			delay: 3000,
		},
		speed: 800,
		slidesPerView: 1,
		spaceBetween: 0,
		centeredSlides: true,
		pagination: {
			el: ".swiper-pagination",
			clickable: true,
		},
		breakpoints: {
			// when window width is >= 719px
			719: {
				speed: 1200,
			},
		},
	});

	// if (www > 719) {

	// } else {
	// 	var topSwiperSp = new Swiper(".topSwiperSp", {
	// 		// Optional parameters
	// 		loop: true,
	// 		effect: "fade",
	// 		autoplay: {
	// 			delay: 3000,
	// 		},
	// 		speed: 800,
	// 		slidesPerView: 1,
	// 		spaceBetween: 0,
	// 		centeredSlides: true,

	// 		pagination: {
	// 			el: ".swiper-pagination",
	// 			clickable: true,
	// 		},
	// 	});
	// }

	var recommendSwiper = new Swiper(".recommendSwiper", {
		// Optional parameters
		loop: true,
		speed: 600,
		autoplay: {
			delay: 3000,
		},
		slidesPerView: 1.5,
		spaceBetween: 10,
		centeredSlides: true,
		breakpoints: {
			// when window width is >= 719px
			719: {
				slidesPerView: 4,
				slidesPerGroup: 1,
				spaceBetween: 12,
				centeredSlides: false,
				pagination: {
					el: null,
				},
			},
		},

		pagination: {
			el: ".swiper-pagination",
			clickable: true,
		},

		navigation: {
			nextEl: ".swiper-button-next",
			prevEl: ".swiper-button-prev",
		},

		scrollbar: {
			el: ".swiper-scrollbar",
		},

		on: {
			init: function () {
				//
			},
		},
	});

	recommendSwiper.autoplay.stop();
	$(".recommendSwiper").waypoint(
		function (direction) {
			var activePoint = $(this.element);
			if (direction === "down") {
				//activePoint.addClass("active");
				//console.log("recommendSwiper");
				recommendSwiper.autoplay.start();
			} else {
				//$("header").addClass("active");
			}
		},
		{ offset: "50%" },
	);

	var categoryImgSwiper = new Swiper("#categoryImgSwiper", {
		// Optional parameters
		loop: false,
		slidesPerView: 3.4,
		spaceBetween: 15,
		centeredSlides: false,
		breakpoints: {
			// when window width is >= 719px
			719: {
				slidesPerView: 8,
				spaceBetween: 40,
				centeredSlides: false,
			},
		},

		pagination: {
			el: ".swiper-pagination",
			clickable: true,
		},
	});

	/*-------------------------------------
LIST
-------------------------------------*/

$(".itemList .colorList").each(function () {
	var colorList = $(this);
	var chip = colorList.find("p:not(.sold-out)");

	// 全カラー欠品の場合は、Liquid側の初期状態を維持
	if (chip.length === 0) {
		return;
	}

	var randomNum = Math.floor(Math.random() * chip.length);
	var target = chip.eq(randomNum);
	var box = colorList.closest(".itemList > li");

	box.find(".colorList li p").removeClass("active");
	target.addClass("active");

	var url = target.data("url");
	var img = target.data("img-url");

	if (url) {
		box.children("a").attr("href", url);
	}

	if (img) {
		box.find(".img img.firstImg").attr("src", img);
	}
});

/*
	$(".itemList .colorList").each(function (index) {
		var tmpColorList = $(this);
		var chip = tmpColorList.find("p");

		var maxNum = chip.length - 1;
		var randomNum = Math.floor(Math.random() * (maxNum + 1));
		//console.log(randomNum);

		var target = $(this).find("li").eq(randomNum).find("p");
		//console.log(target);

		//
		var box = $(this).closest(".itemList > li");
		box.find(".colorList li p").removeClass("active");
		target.addClass("active");

		var url = target.data("url");
		var img = target.data("img-url");

		box.find("a").attr("href", url);
		box.find(".img img").attr("src", img);
		//target.trigger("click");

		//return false;
	});
*/

/*
	$(".colorList li a,.colorList li p").click(function () {
		var box = $(this).closest(".itemList > li");
		box.find(".colorList li p").removeClass("active");
		$(this).addClass("active");

		var url = $(this).data("url");
		var img = $(this).data("img-url");

		box.find("a").attr("href", url);
		box.find(".img img").attr("src", img);

		return false;
	});
*/

// 手動クリック：欠品中でも画像とカラー表示は切り替える
$(".colorList li a, .colorList li p").on("click", function (event) {
	event.preventDefault();
	event.stopPropagation();

	var target = $(this);
	var box = target.closest(".itemList > li");

	box.find(".colorList li p").removeClass("active");
	target.addClass("active");

	var url = target.data("url");
	var img = target.data("img-url");
	var isSoldOut = target.hasClass("sold-out");

	// 欠品中でも画像は表示する
	if (img) {
		box.find(".img img.firstImg").attr("src", img);
	}

	// 在庫があるカラーを選んだときだけリンク先を変更
	// 欠品カラーでは、直前の販売可能バリエーションURLを維持
	if (!isSoldOut && url) {
		box.children("a").attr("href", url);
	}

	return false;
});

	function ajustTtl(target) {
		$(target).each(function (index) {
			var tmp = $(this);
			var ttl = tmp.find(".subTtl").text();

			if (ttl.indexOf("DESK") != -1 || ttl.indexOf("TABLE") != -1) {
				//console.log(ttl);

				//SEMIORDERを含む場合の処理
				for (var i = 0; i < legArr2.length; i++) {
					var word = legArr2[i];
					var word2 = word.replace(" / ", "");
					//console.log(word);

					if (ttl.indexOf(word) != -1) {
						var ttl2 = ttl.replace(word, "");
						tmp.find(".ttl").text(word2);
						tmp.find(".subTtl").text(ttl2);

						break;
					}
				}
			}
		});
	}
	ajustTtl(".itemList > li");

	/*-------------------------------------
recommendations
-------------------------------------*/
	if ($("#product-recommendations").length >= 1) {
		// 監視ターゲットの取得
		const target = document.getElementById("product-recommendations");

		// オブザーバーの作成
		const observer = new MutationObserver((records) => {
			// 変化が発生したときの処理を記述
			//console.log("recommendations");
			ajustTtl("#recommendSwiper a");
			makeRecentSwiper("#recommendSwiper");
		});

		// 監視の開始
		observer.observe(target, {
			childList: true,
		});
	}

	//jquery.products.js
	//sec-recently.liquid
	if ($("#recentSwiper").length >= 1) {
		// 監視ターゲットの取得
		const target2 = document.getElementById("recentSwiper");

		// オブザーバーの作成
		const observer2 = new MutationObserver((records) => {
			// 変化が発生したときの処理を記述
			//console.log("recommendations");
			ajustTtl("#recentSwiper a");
		});

		// 監視の開始
		observer2.observe(target2, {
			childList: true,
		});
	}

	function makeRecentSwiper(target) {
		var tmp = $(target);
		var box = tmp.closest(".recentSwiperBox");
		//console.log(box);

		var recentSwiper = new Swiper(tmp[0], {
			// Optional parameters
			loop: true,
			slidesPerView: 2,
			spaceBetween: 10,
			centeredSlides: true,
			breakpoints: {
				// when window width is >= 719px
				719: {
					loop: false,
					slidesPerView: 5,
					slidesPerGroup: 1,
					spaceBetween: 20,
					centeredSlides: false,
					pagination: {
						el: null,
					},
				},
			},

			navigation: {
				nextEl: box.find(".swiper-button-next")[0],
				prevEl: box.find(".swiper-button-prev")[0],
			},
		});
	}
	//makeRecentSwiper("#recentSwiper");

	// $(".recentSwiper").each(function (index) {
	// 	var tmp = $(this);
	// 	var box = tmp.closest(".recentSwiperBox");
	// 	console.log(box);

	// 	var recentSwiper = new Swiper(tmp[0], {
	// 		// Optional parameters
	// 		loop: true,
	// 		slidesPerView: 2,
	// 		spaceBetween: 10,
	// 		centeredSlides: true,
	// 		breakpoints: {
	// 			// when window width is >= 719px
	// 			719: {
	// 				loop: false,
	// 				slidesPerView: 5,
	// 				slidesPerGroup: 1,
	// 				spaceBetween: 20,
	// 				centeredSlides: false,
	// 				pagination: {
	// 					el: null,
	// 				},
	// 			},
	// 		},

	// 		navigation: {
	// 			nextEl: box.find(".swiper-button-next")[0],
	// 			prevEl: box.find(".swiper-button-prev")[0],
	// 		},
	// 	});
	// });

	/*-------------------------------------
ABOUT
-------------------------------------*/

	//console.log("swiper initialized");
	var lightbox = new PhotoSwipeLightbox({
		gallery: ".materialList",
		children: "a",
		pswpModule: PhotoSwipe,
	});
	lightbox.init();
	if (www > 719) {
	}

	// var lightbox = new PhotoSwipeLightbox({
	// 	gallery: ".projectsList",
	// 	children: "a",
	// 	pswpModule: PhotoSwipe,
	// });
	// lightbox.init();
	// if (www > 719) {
	// }

	$(".faqList li .ttl").click(function () {
		var btn = $(this);
		$(".faqList li .ttl").not(btn).removeClass("active");
		btn.toggleClass("active");

		var target = btn.next(".desp");
		$(".faqList li .desp").not(target).slideUp(300);
		target.slideToggle(300);

		return false;
	});

	/*-------------------------------------
LEARN MORE
-------------------------------------*/

	if ($(".learnSwiper").length >= 1) {
		var learnSwiper = new Swiper(".learnSwiper", {
			loop: true,
			speed: 600,
			autoplay: {
				delay: 3000,
				disableOnInteraction: false,
			},
			initialSlide: 1, //SHOW ROOMを中央に
			slidesPerView: "auto",
			spaceBetween: 10,
			centeredSlides: true,
			breakpoints: {
				// when window width is >= 719px
				719: {
					spaceBetween: 12,
				},
			},
			navigation: {
				nextEl: ".learnNext",
				prevEl: ".learnPrev",
			},
		});

		learnSwiper.autoplay.stop();
		$(".learnSwiper").waypoint(
			function (direction) {
				if (direction === "down") {
					learnSwiper.autoplay.start();
				}
			},
			{ offset: "80%" },
		);
	}

	/*-------------------------------------
SHOW ROOM
-------------------------------------*/

	if ($(".showroomSwiper").length >= 1) {
		var showroomSwiper = new Swiper(".showroomSwiper", {
			//3枚のためloopではなくrewind
			rewind: true,
			speed: 600,
			slidesPerView: 1,
			effect: "fade",
			fadeEffect: {
				crossFade: true,
			},
			navigation: {
				nextEl: ".showroomNext",
				prevEl: ".showroomPrev",
			},
			on: {
				slideChange: function () {
					$(".showroomThumbs li").removeClass("active").eq(this.realIndex).addClass("active");
				},
			},
		});

		$(".showroomThumbs li").click(function () {
			showroomSwiper.slideTo($(this).index());
		});
	}

	/*-------------------------------------
COMPANY
-------------------------------------*/
	let cursorX = 0,
		cursorY = 0;

	var companySwiper = new Swiper(".companySwiper", {
		loop: true,
		spaceBetween: 2,
		//speed: 8000,
		speed: 300,
		allowTouchMove: true, // スワイプ無効
		// autoplay: {
		// 	delay: 0, // 途切れなくループ
		// },
		centeredSlides: false,
		slideToClickedSlide: false,
		slidesPerView: "auto",
		spaceBetween: 10,
		freeMode: true,
		touchStartPreventDefault: false,
		breakpoints: {
			// when window width is >= 719px
			719: {
				slidesPerView: "auto",
				spaceBetween: 20,
				centeredSlides: false,
				//speed: 18000,
				speed: 300,
			},
		},
		on: {
			touchStart: function (e) {
				var tmpSwiper = $(this["el"]);
				tmpSwiper.addClass("draging");
				$(".c-cursorInner").addClass("mini");

				// console.log(e.touches[0]);

				// cursorX = e.touches[0].clientX;
				// cursorY = e.touches[0].clientY;

				// console.log(cursorX);
				// console.log(cursorY);

				//$(window).trigger("mousemove");
				//mouseMove();
			},
			touchMove: function (e) {
				//console.log(e);
				//window.addEventListener("mousemove", mouseMove, false);
			},
			touchEnd: function (e) {
				var tmpSwiper = $(this["el"]);
				tmpSwiper.removeClass("draging");
				$(".c-cursorInner").removeClass("mini");
			},

			init: function () {},
		},
	});

	if ($(".c-cursor").length >= 1) {
		window.addEventListener("mousemove", mouseMove);
		//window.addEventListener("drag", mouseMove);
	}

	$(".companySwiper").hover(
		function () {
			$("html").addClass("is-carouselFocus");
		},
		function () {
			$("html").removeClass("is-carouselFocus");
		},
	);

	function mouseMove(e) {
		cursorX = e.clientX;
		cursorY = e.clientY;

		$(".c-cursor").css("transform", "translateX(" + cursorX + "px) translateY(" + cursorY + "px)");
	}

	/*-------------------------------------
GUIDE
-------------------------------------*/
	//タブ切り替え（#guide1〜#guide10）
	function showGuideTab(hash) {
		if (!/^#guide\d+$/.test(hash)) return false;

		var targetUrl = $(".guideTab").filter(hash);
		if (targetUrl.length == 0) return false;

		$(".guideTab").not(targetUrl).hide();
		targetUrl.fadeIn(200);

		$(".guideList a").removeClass("active");
		$('.guideList a[href="' + hash + '"]').addClass("active");

		return true;
	}

	//タブ切り替え時にURLの#も変更（リロードしても同じタブを表示）
	function changeGuideTab(hash) {
		if (showGuideTab(hash) && location.hash != hash) {
			history.pushState(null, "", hash);
		}
	}

	if ($(".guideTab").length >= 1) {
		if (showGuideTab(urlHash)) {
			$("html, body").stop().animate({ scrollTop: 0 }, 10, "swing");
		}

		//ブラウザの戻る・進む、同ページ内の#リンク
		$(window).on("popstate", function () {
			showGuideTab(location.hash.indexOf("guide") != -1 ? location.hash : "#guide1");
		});
	}

	$(".guideList a").click(function () {
		changeGuideTab($(this).attr("href"));

		return false;
	});

	$(".shippingBtn").click(function () {
		changeGuideTab($(this).attr("href"));

		return false;
	});

	$(".changeGuideTab").click(function () {
		changeGuideTab($(".guideList a").eq(5).attr("href"));

		return false;
	});

	/*-------------------------------------
RESIZE
-------------------------------------*/

	$(window).on("resize", adjustResize);

	function adjustResize() {
		www = $(window).width();
		hhh = $(window).height();

		// if (www < 719 && !detailSwiperFlg) {
		// 	createDetailSwiper();
		// 	detailSwiperFlg = true;
		// } else if (www >= 719 && detailSwiperFlg) {
		// 	detailSwiper.destroy(false, true);
		// 	detailSwiperFlg = false;
		// }
	}
	adjustResize();

	/*-------------------------------------
POPUP
-------------------------------------*/
	if (www < 719) {
		$(".popupSp").magnificPopup({
			type: "inline",
			closeOnContentClick: false,
			closeBtnInside: false,
			mainClass: "mfp-img-mobile mfp-fade",
			closeOnBgClick: true,
			removalDelay: 300,

			gallery: {
				enabled: false,
			},
			callbacks: {
				open: function () {
					preTop = $(window).scrollTop();
					$("html,body").addClass("hiddenBox");
					setTimeout(function () {
						$("html,body").addClass("hiddenBox");
					}, 100);

					$("html, body").animate({ scrollTop: preTop }, 0, "swing");
				},
				beforeClose: function () {
					//$("html, body").animate({scrollTop:preTop}, 0, "swing");
				},
				close: function () {
					$("html,body").removeClass("hiddenBox");

					$("html, body").animate({ scrollTop: preTop }, 0, "swing");

					$(window).trigger("resize");
				},

				change: function () {},
			},
		});
	} else {
		$("a.popupSp").click(function () {
			return false;
		});
	}

	setTimeout(function () {
		$("body").addClass("active");
	}, 300);

	setTimeout(function () {
		$(".pageTtl").addClass("active");
	}, 1000);

	/*-------------------------------------
WAYPOINT
-------------------------------------*/

	www = $(window).width();

	if (www > 719) {
		var ppp = "80%";
	} else {
		var ppp = "80%";
	}

	$(".itemList > li").waypoint(
		function (direction) {
			var activePoint = $(this.element);
			if (direction === "down") {
				activePoint.addClass("active");
			} else {
				//$("header").addClass("active");
			}
		},
		{ offset: ppp },
	);
	$(".collectionList li").waypoint(
		function (direction) {
			var activePoint = $(this.element);
			if (direction === "down") {
				activePoint.addClass("active");
			} else {
				//$("header").addClass("active");
			}
		},
		{ offset: ppp },
	);

	$(".fadeSimple").waypoint(
		function (direction) {
			var activePoint = $(this.element);
			if (direction === "down") {
				activePoint.addClass("active");
			} else {
				//activePoint.removeClass('active');
			}
		},
		{ offset: ppp },
	);

	$(".fade").waypoint(
		function (direction) {
			var activePoint = $(this.element);
			if (direction === "down") {
				activePoint.addClass("active");
			} else {
				//activePoint.removeClass('active');
			}
		},
		{ offset: ppp },
	);

	$(".fadeFast").waypoint(
		function (direction) {
			var activePoint = $(this.element);
			if (direction === "down") {
				activePoint.addClass("active");
			} else {
				//activePoint.removeClass('active');
			}
		},
		{ offset: "90%" },
	);

	$(".fadeLeft").waypoint(
		function (direction) {
			var activePoint = $(this.element);
			if (direction === "down") {
				activePoint.addClass("active");
			} else {
				//activePoint.removeClass('active');
			}
		},
		{ offset: ppp },
	);

	$(".fadeLeftSp").waypoint(
		function (direction) {
			var activePoint = $(this.element);
			if (direction === "down") {
				activePoint.addClass("active");
			} else {
				//activePoint.removeClass('active');
			}
		},
		{ offset: ppp },
	);

	$(".fadeRight").waypoint(
		function (direction) {
			var activePoint = $(this.element);
			if (direction === "down") {
				activePoint.addClass("active");
			} else {
				//activePoint.removeClass('active');
			}
		},
		{ offset: ppp },
	);

	$(".maskRight").waypoint(
		function (direction) {
			var activePoint = $(this.element);
			if (direction === "down") {
				activePoint.addClass("active");
			} else {
				//activePoint.removeClass('active');
			}
		},
		{ offset: ppp },
	);

	$(".maskLeft").waypoint(
		function (direction) {
			var activePoint = $(this.element);
			if (direction === "down") {
				activePoint.addClass("active");
			} else {
				//activePoint.removeClass('active');
			}
		},
		{ offset: ppp },
	);

	$(".maskTop").waypoint(
		function (direction) {
			var activePoint = $(this.element);
			if (direction === "down") {
				activePoint.addClass("active");
			} else {
				//activePoint.removeClass('active');
			}
		},
		{ offset: ppp },
	);

	$(".maskBottom").waypoint(
		function (direction) {
			var activePoint = $(this.element);
			if (direction === "down") {
				activePoint.addClass("active");
			} else {
				//activePoint.removeClass('active');
			}
		},
		{ offset: ppp },
	);

	/*-------------------------------------
COMMON
-------------------------------------*/

	function commonEvent() {
		adjustResize();

		$("a.scroll").click(function () {
			//$.magnificPopup.close();

			var speed = 500;
			var href = $(this).attr("href");
			if (href == "#" || href == "") {
				var target = "html";
			} else {
				var target = $(href);
				var sa = 0;

				if (www > 980) {
					sa = 160;
				} else {
					sa = 0;
				}

				var position = target.offset().top - sa;

				hideFlg = false;
				$("header").addClass("hide");

				$("html, body").animate({ scrollTop: position }, speed, "swing");

				setTimeout(function () {
					hideFlg = true;
				}, 600);

				return false;
			}
		});

		var topBtn = $("#pagetop");

		//スクロールしてトップ
		topBtn.click(function () {
			$("body,html").animate(
				{
					scrollTop: 0,
				},
				500,
			);
			return false;
		});
	}
	commonEvent();
});
